module.exports = {
	"commitCount": 1,
	"commitMembers": [
		{
			"count": 1,
			"authorName": "Bobjoy"
		}
	],
	"commitUniqueCount": 1
};


//////////////////
// WEBPACK FOOTER
// ./zh-CN/components/button-tab_git_metas.json
// module id = 2487
// module chunks = 82